import React from 'react'
import { connect } from 'react-redux'

import Header from './default/Header'
import Footer from './default/Footer'
import Alert from '../module/alert'
import SimpleHeader from "./simpleMobile/Header";

const NonLayout = ({ children }) => {
    return (
        <React.Fragment>
            <SimpleHeader />
            <div id="container">{children}</div>
            <Alert />
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    // auth: state.auth,
})

export default connect(mapStateToProps, null)(NonLayout)